import styles from './PaymentSortFilter.module.scss';
import { PaymentSortOptions, Sort } from 'state';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

type Props = {
    paymentSort: Sort | undefined,
    onPaymentSortChange: (value: Sort) => void
};

const PaymentSortFilter = ({ paymentSort, onPaymentSortChange: onStatusChange }: Props) => (
    <DropDownButton 
        className={styles.control}
        items={PaymentSortOptions}
        onItemClick={(e) => onStatusChange(e.item === 'Sort By' ? undefined : e.item)}
        tabIndex={0}
        text={<span className={styles.text}>{paymentSort?.text}</span>}
    />
);
export default PaymentSortFilter;